import { WorkflowStatusCountResponse } from './types'
import type { WorkflowFilterStatus } from '@app/shared/types/sf-data'

export const isWorkflowStatus = (
  value: string
): value is WorkflowFilterStatus => {
  return [
    'show-all',
    'todos',
    'checks',
    'unreconciled',
    'unreviewed_by_me',
    'starred',
  ].includes(value)
}

export const isValidWorkflowStatusResponseKey = (
  value: string
): value is keyof WorkflowStatusCountResponse => {
  return [
    'todos',
    'checks',
    'unreconciled',
    'unreviewedByMe',
    'starred',
    'total',
  ].includes(value)
}
